






import { computed, defineComponent } from "@vue/composition-api";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import providers from "@/lib/api";

export default defineComponent({
  name: "ContentFeedPinController",
  props: {
    contentFeed: { type: Object as () => ContentFeed, required: true },
    pinnedPostId: { type: String, default: null },
  },
  setup(props, { emit }) {
    const isPinned = computed(() => props.contentFeed.id === props.pinnedPostId);

    const onToggle = async (feedId: string) => {
      if (props.contentFeed.id !== feedId) return;
      try {
        await providers.ContentSetProvider.update({ data: { id: feedId, pinned: !isPinned.value } });
      } finally {
        emit("togglePin", feedId, !isPinned.value);
      }
    };
    return {
      isPinned,
      onToggle,
    };
  },
});
